/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
import { useEffect, useState } from "react";
import { Box, Button, Chip } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";

import {LuiToolbar} from "@jda/lui-common-component-library-mui5";
import { TITLES } from "./constants";
import { useStyles } from "./styles";
import { getRealmEntitlements } from "../../store/realm/realm";
import { selectSelectedRealm } from "../../store/realm/realmSelector";
import EmptyComponent from "../../shared/emptyComponent/EmptyComponent";
import { selectSelectedCustomer } from "../../store/customer/customerSelector";
import useWindowDimensions from "../../shared/windowDimensions/windowDimensions";
import { selectSelectedSubEnterprise } from "../../store/subEnterprise/subEnterpriseSelector";
import EditEntitlementDialog from "../EditEntitlementDialog/EditEntitlementDialog";

const RealmEntitlements = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { height } = useWindowDimensions();

  const selectedRealm = useSelector(selectSelectedRealm);
  const selectedCustomer = useSelector(selectSelectedCustomer);
  const selectedSubEnterprise = useSelector(selectSelectedSubEnterprise);

  const [entitlements, setEntitlements] = useState([]);
  const [openEditEntitlementDialog, setOpenEditEntitlementDialog] = useState(false);

  useEffect(() => {
    getRealmEntitlementsList();
  }, [selectedRealm.id]);

  const getRealmEntitlementsList = () => {
    const payload = {
      id: selectedRealm.id,
      customerId: selectedCustomer.id,  
      subEnterpriseId: selectedSubEnterprise.id,
    };
    getRealmEntitlements(dispatch, payload);
  }
  useEffect(() => {
    setEntitlements(selectedRealm?.entitlements);
  }, [selectedRealm.id, selectedRealm?.entitlements]);

  return (
    <Box>
      <Box className={classes.root} height={height - 250}>
         {entitlements?.length !== 0 && <Box>
          <LuiToolbar
            rightZone={{component: (<Button
          color="primary"
          disableElevation
          variant="outlined"
          name="editEntitlement"
          className={classes.editButton}
          data-testid="add-entitlements-button"
          onClick={() => setOpenEditEntitlementDialog(true)}
        >
          {entitlements && entitlements.length ? TITLES.EDIT : TITLES.ADD}
        </Button>)}}
          />
        </Box>}
        <Box className={classes.entitlementsWrap}>
          {entitlements && entitlements.length > 0 && entitlements.map((item: any, index: number) => (
            <Chip
              key={index}
              size="small"
              color="primary"
              label={item.name}
              className={classes.chip}
              data-testid="selected-module"
            />
          ))}
        </Box>

       
      </Box>

      <EditEntitlementDialog
        refreshOnSave={getRealmEntitlementsList}
        open={openEditEntitlementDialog}
        closeHandler={() => setOpenEditEntitlementDialog(false)}
      />

      {!entitlements || !entitlements.length &&
        <EmptyComponent
          disableCreateAction={false}
          title={TITLES.ADD_ENTITLEMENTS}
          buttonText={TITLES.ADD_ENTITLEMENTS}
          handleOnCreateAction={() => setOpenEditEntitlementDialog(true)}
        />
      }
    </Box>
  );
};

export default RealmEntitlements;
